import React, { useEffect, useState } from "react";
import Breadcrumb from "../components/common/Breadcrumb";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import ContactArea from "../components/Contact/ContactArea";
import ContactAreaTwo from "../components/Contact/ContactAreaTwo";
import ContactMap from "../components/Contact/ContactMap";
import SEO from "../components/seo";
import { useLanguage } from "../contexts/LanguageContext";

const translationKeys = {
  CONTACT_PAGE_TITLE: "Contact",
  BREADCRUMB_TITLE: "Contact",
  BREADCRUMB_SUBTITLE: "Get In Touch",
  HOME: "Home",
};

const Contact = () => {
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState(translationKeys);

  useEffect(() => {
    const translateAll = async () => {
      const keys = Object.keys(translationKeys);
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        try {
          const translated = await translateContent(translationKeys[key]);
          newTranslations[key] = translated || translationKeys[key];
        } catch {
          newTranslations[key] = translationKeys[key];
        }
      });
      await Promise.all(translationPromises);
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, translateContent]);

  return (
    <main>
      <SEO pageTitle={translations.CONTACT_PAGE_TITLE} />
      <Header />
      <Breadcrumb title={translations.BREADCRUMB_TITLE} subtitle={translations.BREADCRUMB_SUBTITLE} homeLabel={translations.HOME} />
      <ContactArea />
      <ContactAreaTwo />
      <ContactMap />
      <Footer />
    </main>
  );
};

export default Contact;